// remember the last clicked productPairEdit (we need to reopen it if the user opens the shoe size modal)
let lastOpenedModal;

/********
 * Matrix
 */

// set up thumbs swiper
let thumbsSwiper = new Swiper('#productThumbs', {
    slidesPerView: 'auto',
    spaceBetween: 10
});

// set up images swiper
let imageSwiper = new Swiper('#productSwiper', {
    slidesPerView: 1,
    spaceBetween: 50,
    thumbs: {
        swiper: thumbsSwiper,
    },
});


// update active variant
let formData = {
    items: []
};

// top cover is based off of sport (GOLD INSOLES)
const sportToTopCover = {
    "Baseball/Softball": "B",
    "Basketball": "A",
    "Ultimate Frisbee": "B",
    "Boxing/Wrestling": "B",
    "Cheerleading": "C",
    "Fitness": "A",
    "Golf": "B",
    "Hiking": "A",
    "Football": "B",
    "Lacrosse": "B",
    "Rugby": "B",
    "Running": "A",
    "Soccer": "C",
    "Tennis/Pickleball": "A",
    "Track & Field": "C",
    "Volleyball": "A",
    "Walking": "A",
    "Other": "A",
}

// function to take variables from product options to a formdata item
function getFormData(options) {
    // gender is a variant (make sure something is checked)
    let gender = options.gender ?? null;

    // sport is a property
    let sport = options.sport ?? null;

    // size is a variant
    let size = options.size ?? null;

    // weight is a property
    let weight = options.weight ?? null;

    // age is a property
    let age = options.age ?? null;

    // Determine product
    let targetProduct = goldWeightToProduct[weight];

    // Determine Top Cover
    let topCover = sportToTopCover[sport]

    // AFTER determining the product (based on the weight) we check on special cases
    // Note we do not touch the weight variable since it's used as a line item property
    // if they are Female and size 151-180, it changes the weight to pro level 3 from level 4 (we have another case for ages 50 and up so we exclude that)
    if (gender === "Female" && weight === "151 - 180lbs" && age !== "50 and Up") {
        targetProduct = goldWeightToProduct["121 - 150lbs"];
    }

    // if they are age 50 & up, we decrease the pro level by 1
    if (age === "50 and Up") {
        if (weight === "261lbs - Up") {
            targetProduct = goldWeightToProduct["231 - 260lbs"];
        } else if (weight === "231 - 260lbs" || weight === "211 - 230lbs") {
            targetProduct = goldWeightToProduct["181 - 210lbs"];
        } else if (weight === "181 - 210lbs" || weight === "151 - 180lbs") {
            targetProduct = goldWeightToProduct["121 - 150lbs"];
        } else if (weight === "121 - 150lbs") {
            targetProduct = goldWeightToProduct["100 - 120lbs"];
        } else {
            targetProduct = goldWeightToProduct["100 - 120lbs"];
        }
    }

    // find the correct variant based on the active options
    let activeVariant = null;
    for (let i = 0; i < targetProduct.variants.length; i++) {
        // here comes the tricky part, Shopfiy might have 5-5.5 OR 5.5-6 ending on the top cover however we're going to receive a size of 5, 5.5 or 6.
        // We need to do a split and find an exact match
        if (
            // size (we s
            targetProduct.variants[i].option1.split("-").includes(size) &&
            // top cover
            targetProduct.variants[i].option2 === topCover &&
            // gender
            targetProduct.variants[i].option3 === gender
        ) {
            activeVariant = targetProduct.variants[i];
            break;
        }
    }

    // check if active variant is not found in any setup
    if (activeVariant == null) {
        return false;
    }

    // return
    return {
        quantity: 1,
        id: activeVariant.id,
        properties: {
            "Age": age,
            "Sport": sport,
            "Weight": weight
        },
        available: activeVariant.available
    };
}

/**************
 Product Slider
 ***************/

// enable swiper
let productOptionSwiper = new Swiper("#productOptionSwiper", {
    allowTouchMove: false,
    autoHeight: true,
    spaceBetween: 30
});

// on change, check if Basketball or Volleyball is selected and show warning
if (document.querySelector("#productOptionSlideNoteSize")) {
    productOptionSwiper.on("slideChange", function () {
        let sport = document.querySelector(`.productOptionSlideLabel.active[data-group="sport"]`)?.dataset?.value
        if (sport === "Golf") {
            document.querySelector("#productOptionSlideNoteSize").textContent = "When ordering for golf, order a size up";
        } else if (sport === "Basketball" || sport === "Volleyball") {
            document.querySelector("#productOptionSlideNoteSize").innerHTML = `Use measurements chart to confirm sizing`;
        } else {
            document.querySelector("#productOptionSlideNoteSize").textContent = "Use measurements chart to confirm sizing";
        }
    });
}


// Progress bar
productOptionSwiper.on("slideChange", function () {
    // enable all buttons
    document.querySelectorAll('.productContentProgressCircleInner').forEach((element) => {
        element.disabled = false;
    });

    // update active progress bar circles
    document.querySelectorAll(".productContentProgressCircleInner")?.forEach((element, index) => {
        if (index <= productOptionSwiper.activeIndex) {
            // we need to wait to add the active class
            // because the progress bar takes 300ms to animate
            setTimeout(() => {
                element.classList.add("active");
            }, 100);
        } else {
            element.classList.remove("active");
        }
    });

    // update active progress bar lines
    document.querySelectorAll(".productContentProgressLineInner").forEach((element, index) => {
        element.classList.remove("active");
        if (index < productOptionSwiper.activeIndex) {
            element.classList.add("active");
        }
    });

    // Progress bar button click slide change
    document.querySelectorAll('.productContentProgressCircleInner.active').forEach((element, index) => {
        element.addEventListener("click", function () {
            productOptionSwiper.slideTo(index);
        });
    });

});

// Progress bar final slide edge cases
// The final form is the last "slide" but isn't a swiper slide.
// We need to add the active class to the final progress bar/circle when
// the last swiper slide option is clicked, which is the weight group for platinum
// and is the age group for silver/gold.
let targetGroup = "age";

document.querySelectorAll(`.productOptionSlideLabel[data-group='${targetGroup}']`)?.forEach(element => {
    element.addEventListener("click", function () {
        // add active class to all progress bar circles
        document.querySelectorAll(".productContentProgressCircleInner")?.forEach((element, index) => {
            element.classList.add("active");
        });
        // add active class to all progress bar lines
        document.querySelectorAll(".productContentProgressLineInner")?.forEach((element, index) => {
            element.classList.add("active");
        });

        // Since we're on the last slide, we need to disable the buttons
        document.querySelectorAll('.productContentProgressCircleInner').forEach((element) => {
            element.disabled = true;
        });
    });
});

// update active variant on click
document.querySelectorAll(".productOptionSlideLabel").forEach(function (element) {
    element.addEventListener("click", function () {

        const group = this.dataset.group;
        const value = this.dataset.value;

        // remove active class from all items in this group
        document.querySelectorAll(`.productOptionSlideLabel[data-group="${group}"]`).forEach(element => element.classList.remove("active"));

        // add active class to this item
        this.classList.add("active");

        // go to next slide
        productOptionSwiper.slideNext();

        // slide back up to top of productOptionSwiper - 200px - only on the shoe slide
        if (group === "size") {
            let elementTop = document.querySelector('#productOptionSwiper').getBoundingClientRect().top + window.scrollY;
            let offset = 300;
            if (window.innerWidth < 800) {
                offset = 250;
            }
            window.scrollTo({
                top: elementTop - offset,
                behavior: 'smooth'
            });
        }

        // check if every group has an active item
        if (document.querySelectorAll(".productOptionSlide").length === document.querySelectorAll(".productOptionSlideLabel.active").length) {
            document.querySelector("#productOptionSwiper").classList.remove("active");
            document.querySelector("#productForm").classList.add("active");
        } else {
            document.querySelector("#productOptionSwiper").classList.add("active");
            document.querySelector("#productForm").classList.remove("active");
            return;
        }

        // create options object
        let options = {};
        document.querySelectorAll(`.productOptionSlideLabel.active`).forEach(element => {
            options[element.dataset.group] = element.dataset.value;
        });

        // save options
        document.querySelector(".productPair").setAttribute("options", JSON.stringify(options));
        document.querySelector(".productPair").classList.add("active");


        // update product
        updateProduct();
    });
})


// back button
document.querySelectorAll(".productOptionSlideNavBack").forEach(function (element) {
    element.addEventListener("click", function () {
        productOptionSwiper.slidePrev();
    });
});

// next button
document.querySelectorAll(".productOptionSlideNavNext").forEach(function (element) {
    element.addEventListener("click", function () {
        productOptionSwiper.slideNext();
    });
});

/*******************
 * Product Pairs
 */

// open edit
document.querySelectorAll(".productPairEdit").forEach(element => {
    element.addEventListener("click", function () {
        // save pair element
        let pairElement = this.closest(".productPair");

        // save option element
        let options = pairElement.getAttribute("options");

        // open modal
        pairElement.querySelector(".productPairModal").showModal();

        // select options
        let optionsParsed = JSON.parse(options);
        pairElement.querySelectorAll(`.productPairModalLabelSelect`).forEach(element => {
            element.value = optionsParsed[element.getAttribute("name")]
        });

        lastOpenedModal = pairElement.querySelector(".productPairModal");
    })
});

// close event
document.querySelectorAll(".productPairModal").forEach(element => {
    element.addEventListener('close', function () {

        // save pair element
        let pairElement = this.closest(".productPair");

        // check if this input has no options, then we hide it (it means they added a product with different options and canclled)
        if (!pairElement.getAttribute("options")) {
            pairElement.classList.remove("active");
        }

    });
})

// trigger close modal
document.querySelectorAll(".productPairModal,.productPairModalCancel,.productPairModalExit").forEach(element => {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            document.querySelector(".productPairModal[open]").close();
        }
    })
});

// form input events
document.querySelectorAll(".productPairModalLabelSelect").forEach(element => element.addEventListener("change", function () {
    // check if the entire form is ready
    let form = this.closest(".productPairModalContent");

    // check if all inputs are entered
    let ready = true;
    form.querySelectorAll(".productPairModalLabelSelect").forEach(input => {
        if (input.selectedIndex === 0) {
            ready = false;
        }
    });

    // update update button
    form.querySelector(".productPairModalUpdate").disabled = !ready;
}));

// update pair
document.querySelectorAll(".productPairModalContent").forEach(element => {
    element.addEventListener("submit", function (e) {
        e.preventDefault();

        // when we close the shoe size modal, it can trigger the productPairModalContent submit event
        // this boolean is here to prevent that
        if (preventSubmit) {
            return;
        }

        // save pair element
        let pairElement = this.closest(".productPair");

        // set this option as active
        pairElement.classList.add("active");

        // update options attribute only if the option isn't the initial one
        let options = {};
        this.closest(".productPairModal").querySelectorAll(`.productPairModalLabelSelect`).forEach(element => {
            if (!element.value.includes("Choose")) {
                options[element.getAttribute("name")] = element.value;
            }
        });

        pairElement.setAttribute("options", JSON.stringify(options));

        // close modal
        document.querySelector(".productPairModal[open]").close();

        updateProduct();
    });
});

// remove
document.querySelectorAll(".productPairRemove").forEach(element => {
    element.addEventListener("click", function () {
        // save pair element
        let pairElement = this.closest(".productPair");

        // remove active and options
        pairElement.classList.remove("active");
        pairElement.removeAttribute("options");

        // update product
        updateProduct();

        // check if there are no more left, reset the swiper to slide 1 and remove active classes on lebels
        if (document.querySelectorAll(".productPair.active").length === 0) {
            document.querySelector("#productOptionSwiper").classList.add("active");
            document.querySelector("#productForm").classList.remove("active");
            document.querySelectorAll(".productOptionSlideLabel.active").forEach(element => element.classList.remove("active"));
            productOptionSwiper.slideTo(0);
            lastOpenedModal = null;
        }
    });
})

// same as first
document.querySelector("#productActionSame").addEventListener("click", function () {
    // check for a free slot
    let nextFree = document.querySelector(".productPair:not(.active)");
    if (nextFree) {
        nextFree.classList.add("active");
        nextFree.setAttribute("options", document.querySelector(".productPair").getAttribute("options"));
    }
    updateProduct();
});

// new pair
document.querySelector("#productActionNew").addEventListener("click", function () {
    //check for a free slot
    let nextFree = document.querySelector(".productPair:not(.active)");
    if (nextFree) {
        nextFree.classList.add("active");
        nextFree.querySelector(".productPairModal").showModal();
    }

    lastOpenedModal = nextFree.querySelector(".productPairModal");
});


function updateProduct() {
    // reset atc button (atc active)
    document.querySelector("#productATC").textContent = "Add To Cart";
    document.querySelector("#productATC").classList.add("active");
    document.querySelector("#productATC").classList.remove("disabled");
    document.querySelector("#productATC").classList.remove("message");

    // show terms
    document.querySelector("#productTerms").classList.remove("active");

    // reset form data
    formData.items = [];
    document.querySelectorAll(".productPairTitle")?.forEach(element => element.classList.remove("active"));
    // hide error message
    document.querySelector("#productATC").classList.remove("active");
    document.querySelectorAll(".productPair.active").forEach((element, index) => {
        // reindex
        element.querySelector(".productPairTitle").textContent = `PAIR ${index + 1}`

        // add formdata
        let options = JSON.parse(element.getAttribute("options"));
        let item = getFormData(options);

        // check if item is not found (variant can't be found)
        if (item === false || !item.available) {
            // hide atc button
            document.querySelector("#productATC").classList.add("active");

            // hide terms
            document.querySelector("#productTerms").classList.add("active");

            let errorMsg = "Sorry, we don't offer a product that meets the selected options.";


            if (!item.available) {
                errorMsg = "Sorry, this product is currently out of stock.";
            }

            if (item === false) {
                errorMsg = "Unavailable — this selection is not currently part of our assortment";
            }


            document.querySelector('.productErrorMsg').textContent = errorMsg;

            // show error message
            document.querySelector("#productError").classList.add("active");

            // find that element
            let productPair = document.querySelector(`.productPair[options='${JSON.stringify(options)}']`);

            // indicate that this pair is invalid by setting title to active
            productPair.querySelector(".productPairTitle").classList.add("active");

            return;
        }


        // show atc
        document.querySelector("#productATC").classList.remove("active");

        // show terms
        document.querySelector("#productTerms").classList.remove("active");

        // hide error message
        document.querySelector("#productError")?.classList.remove("active");

        // check for duplicates (id and property, if you check the entire object, the id won't match)
        for (let i = 0; i < formData.items.length; i++) {
            if (formData.items[i].id === item.id && JSON.stringify(formData.items[i].properties) === JSON.stringify(item.properties)) {
                formData.items[i].quantity++;
                return;
            }
        }

        // add item to form data
        formData.items.push(item);
    });
}

// dynamic shoe size title
document.querySelectorAll(".productOptionSlideLabel[data-group='gender']").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productOptionSlideTitleGender').textContent = element.textContent;
    })
})


// pre-selects
function preselectURL() {
    const url = new URL(window.location.href);

    let gender = url.searchParams.get("gender");
    if (gender != null) {
        document.querySelector(`.productOptionSlideLabel[data-group="gender"][data-value="${gender}"]`)?.classList.add("active")
    }

    let sport = url.searchParams.get("sport");
    if (sport != null) {
        // undo sport url parameter adjustments
        sport = sport.replace("_", " & ").replace("-", "/");
        document.querySelector(`.productOptionSlideLabel[data-group="sport"][data-value="${sport}"]`)?.classList.add("active")
    }
}

preselectURL();


/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // add product
    await addProduct(formData);

    // stop loading
    this.classList.remove("loading");

    // check for upsell
    await openUpsell();

    // open cart
    await openCart();
});


/********************************** Shoe Size **********************************/

// when the shoe size modal is opened, it closes all other modals
// if this happens while the product customizer dialog is opened, it causes the form to submit
// we need to prevent that submit

let preventSubmit = false;

// open shoe size modal
document.querySelectorAll(".openShoeSize").forEach(element => {
    element.addEventListener("click", function () {
        // Find the correct shoe size modal

        // The modal to open is based on the sport
        // Gold: Basketball, fitness, racquet sports, running, volleyball, walking/hiking, everyday
        // Black: Baseball, boxing, football, golf, lacrosse, rugby, ultimate frisbee, [NEW -> ]Cheerleading, Track, Soccer
        // Red: REMOVED and uses black now, was Cheerleading, Track, Soccer
        let sport = document.querySelector(`.productOptionSlideLabel.active[data-group="sport"]`)?.dataset?.value;

        if (sport === "Basketball" || sport === "Fitness" || sport === "Tennis/Pickleball" || sport === "Running" || sport === "Volleyball" || sport === "Hiking" || sport === "Walking" || sport === "Other") {
            document.querySelector('#shoeSizeGold').showModal();
        } else {
            document.querySelector('#shoeSizeBlack').showModal();
        }

        document.querySelector("body").classList.add("noScroll");

        // prevent form submissions
        preventSubmit = true;
    })
});

//close shoe size event listener
document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
    element.addEventListener("click", async function () {
        let target = this.dataset.target;
        await closeSize(target);
        // open back up modal once the shoe size modal is closed
        if (lastOpenedModal) {
            lastOpenedModal.showModal();
        }
        preventSubmit = false;

    });
});

//close shoe size event listener
document.querySelectorAll(".shoeSize")?.forEach(function (element) {
    element.addEventListener("click", async function (e) {
        if (e.target === this) {
            let target = element.id;
            await closeSize(target);

            // open back up modal once the shoe size modal is closed
            if (lastOpenedModal) {
                lastOpenedModal.showModal();
            }

            preventSubmit = false;
        }
    });
});


// close shoe size
function closeSize(target) {
    document.querySelector(`#${target}`).close();
    document.querySelector("body").classList.remove("noScroll");
}

// register dialogs
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

// open moneyBack dialog
document.querySelectorAll('.openMoneyBack').forEach(function (element) {
    element.addEventListener('click', function () {
        document.querySelector("#moneyBack").showModal();
        document.querySelector("body").classList.add("noScroll");
    });
})

// close moneyBack
function closePopup() {
    document.querySelector("#moneyBack").close();
    document.querySelector("body").classList.remove("noScroll");
}

// close moneyBack event listener
document.querySelectorAll(".moneyBackClose").forEach(function (element) {
    element.addEventListener("click", closePopup);
});

document.querySelector("#moneyBack").addEventListener("click", function (e) {
    if (e.target === this) {
        closePopup();
    }
})

// close event
document.querySelector("#moneyBack").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));


/**************
 Product Upsells
 ***************/

    // upsell swiper
let upsellSwiper = new Swiper('.upsellSwiper', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.upsellSwiperFooterPag',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },
    });

// store the swiper slides to use for later
let socksSlide = document.querySelector('#upsellSocks');
let boostsSlide = document.querySelector('#upsellBoosts');
let gripsSlide = document.querySelector('#upsellGrips');
let clogsSlide = document.querySelector('#upsellClogs');
let silverSlide = document.querySelector('#upsellSilver');

// map the sportToUpsell titles to the slides
let upsellTitleToUpsellSlide = {
    "Ankle Boosts": boostsSlide,
    "Grip Socks": gripsSlide,
    "Propulsion Socks": socksSlide,
    "Recovery Clogs": clogsSlide,
    "Silver Insoles": silverSlide
}

// add to cart event listeners
document.querySelectorAll(".upsellCheckout").forEach(element => {
    element.addEventListener("click", async function () {

        // Used in Discount Kit to target specific upsell products
        let discountProperty = '';

        // start loading
        this.classList.add("loading");

        // determine the first insole gender and size
        const firstPair = JSON.parse(document.querySelector(".productPair.active").getAttribute("options"));
        const firstPairGender = firstPair.gender;
        const firstPairSize = firstPair.size;

        // determine the variant id
        let variantID;
        let available = true;

        if (element.classList.contains("boosts")) {
            discountProperty = 'boosts_upsell';
            if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 9)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 10.5))) {
                variantID = 42757218402475; // medium
            } else {
                variantID = 42757218435243; // large
            }
        } else if (element.classList.contains("silverInsole")) {


        } else if (element.classList.contains("clogs")) {

            discountProperty = 'clog_upsell';

            // find the variant based on the selected input
            let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked').value;
            let clogProduct = JSON.parse(element.dataset.product);

            const insoleColorToClogColor = {
                "Black": "Carbon Black",
                "White": "Cloud White",
            }

            // find new variant based on the options
            let clogVariant = clogProduct.variants.find((variant) => {
                return (
                    variant.options[0] === insoleColorToClogColor[color] &&
                    variant.options[1] === firstPairGender &&
                    (
                        variant.options[2].split('-')[1] === firstPairSize ||
                        variant.options[2].split('-')[0] === firstPairSize
                    )
                );
            });

            if (clogVariant.available) {
                variantID = clogVariant.id;
            } else {
                available = false;
            }
        } else if (element.classList.contains("grips")) {
            if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 8)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 11))) {
                variantID = 51654863061359 // medium
            } else if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 12)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 13))) {
                variantID = 51654863094127; // large
            } else {
                variantID = 51654863126895; // xlarge
            }
        } else {
            // compression socks
            discountProperty = 'compression_socks_upsell';
            if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 7)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 9))) {
                variantID = 42970044924075 // medium
            } else if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 12)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 14))) {
                variantID = 42970045382827; // large
            } else {
                variantID = 42970045415595; // xlarge
            }
        }

        // if this has already been added, remove it from the cart
        if (this.classList.contains("added")) {
            let cart = await getCart();

            // find the item
            let item = cart.items.find(item => item.variant_id === variantID);

            // if there is no item, return
            if (!item) {
                this.textContent = "Add to Cart";
                this.classList.remove("loading");
                return;
            }

            await changeProduct({
                id: item.key,
                quantity: item.quantity - 1
            });

            this.classList.remove("added");
            this.textContent = "Add to Cart";
            this.classList.remove("loading");
            return;
        }


        // add
        if (available) {
            await addProduct({
                quantity: 1,
                id: variantID,
                properties: {
                    _upsell: true,
                    _discount_kit: discountProperty
                }
            });
        }

        // stop loading
        this.classList.remove("loading");

        element.textContent = "Remove";
        this.classList.add("added");


        // if all upsells have been added, close
        if (document.querySelectorAll(".upsellCheckout.added").length === document.querySelectorAll(".upsellCheckout").length) {
            this.closest(".upsell").close();
        }

        // if there is a next slide, slide to it
        if (this.closest(".swiper-slide").nextElementSibling) {
            upsellSwiper.slideNext();
        }
    });
});


// delete the hidden upsells from the DOM
document.querySelector('.hiddenUpsells').remove();

// controls
document.querySelector('.upsellContentControl.prev').addEventListener('click', function () {
    upsellSwiper.slidePrev();
});

document.querySelector('.upsellContentControl.next').addEventListener('click', function () {
    upsellSwiper.slideNext();
});


/********************************************** Upsell ***************************************/

function isSizeInRange(currentSize, min, max) {
    const range = currentSize.split('-').map(parseFloat);
    const size = parseFloat(range[0]);
    return !isNaN(size) && size >= min && size <= max;
}

// open ankle upsell
async function openUpsell() {

    // get sport
    let options = JSON.parse(document.querySelector(`.productPair.active`).getAttribute("options"));

    let sport = options.sport;

    // get the sport to upsell slides
    let slides = sportToUpsell[sport]

    // if there are no slides, return
    if (!slides) {
        return;
    }


    // update swiper controls
    document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.remove("active"));
    document.querySelector('.upsellSwiperFooter').classList.remove("active");

    if (slides.length > 1) {
        document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.add("active"));
        document.querySelector('.upsellSwiperFooter').classList.add("active");
    }

    // remove all swiper slides
    upsellSwiper.removeAllSlides();


    // TEMP
    // upsellSwiper.appendSlide(upsellTitleToUpsellSlide['Silver Insoles']);

    // add in the correct slides
    for (let slide of slides) {
        upsellSwiper.appendSlide(upsellTitleToUpsellSlide[slide]);
    }

    // check if clog is available in selected variant, if not disable
    // determine the first insole gender and size
    let firstPair = JSON.parse(document.querySelector(".productPair.active").getAttribute("options"));
    let firstPairGender = firstPair.gender;
    let firstPairSize = firstPair.size;

    // find the variant based on the selected input
    let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked')?.value;
    let clogProduct = JSON.parse(document.querySelector('#upsellClogs').querySelector('.upsellCheckout')?.dataset.product);

    const insoleColorToClogColor = {
        "Black": "Carbon Black",
        "White": "Cloud White",
    }

    // find new variant based on the options
    let clogVariant = clogProduct.variants.find((variant) => {
        return (
            variant.options[0] === insoleColorToClogColor[color] &&
            variant.options[1] === firstPairGender &&
            (
                variant.options[2].split('-')[1] === firstPairSize ||
                variant.options[2].split('-')[0] === firstPairSize
            )
        );
    });

    if (!clogVariant) {
        // disable the clog upsell
        document.querySelector('#upsellClogs').querySelector('.upsellCheckout').disabled = true;
        document.querySelector('#upsellClogs').querySelector('.upsellCheckout').textContent = 'Unavailable';

    }

    // open the upsell
    document.querySelector(`#upsell`).showModal();

    document.querySelector("body").classList.add("noScroll");

    // wait for modal to be closed
    await new Promise((resolve, reject) => {
        document.querySelector(`#upsell`).addEventListener("close", function (e) {
            resolve('closed');
        });
    });
}

// close events
document.querySelectorAll(".upsell").forEach(element => {
    // exist backdrop
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
            document.querySelector("body").classList.remove("noScroll");

        }
    })
});

// close upsell via button
document.querySelectorAll(".upsellClose").forEach(element => {
    element.addEventListener("click", function () {
        this.closest(".upsell").close();
        document.querySelector("body").classList.remove("noScroll");
    });
});


// register dialog
dialogPolyfill.registerDialog(document.querySelector("#upsell"));